export const domainTag = 'frontend_webOrder_';

export const featureFlags = [
  'altGoogleAnalyticsPurchaseEvent',
  'clearAllCreatedOrersAfterError',
  'targetedLoading',
  'uiRedesign',
] as const;

export type FeatureFlag = typeof featureFlags[number];
